<template>
    <div class="verAddCon"   v-if='showModel'>

             <div v-if="type==1" class="title">{{title}}</div>
             <Icon v-if="type==1" class="colseButton" type="ios-close-circle" size='30' style="color:#ed4014" @click="cancel" />
            
            <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="120" style="display:flex;flex-wrap:wrap">
    
                <div style="marginLeft:50px">

                    <FormItem v-if="type==2" :label="$t('setting.id')" prop="id" style="width: 500px">
                        <Input type="text" :value="formData.id" :placeholder="$t('inputPlaceholder')" disabled></Input>
                    </FormItem>
                   
                    <FormItem :label="$t('setting.companyName')" prop="companyName" style="width: 500px">
                        <Input type="text" v-model.trim="formData.companyName" maxlength="50"  :placeholder="$t('inputPlaceholder')" ></Input>
                    </FormItem>

                     <FormItem :label="$t('setting.macMaker')" prop="macMaker" style="width: 500px">
                        <Input type="text" v-model.trim="formData.macMaker"  maxlength="100"  :placeholder="$t('inputPlaceholder')"></Input>
                    </FormItem>
        
                    <FormItem :label="$t('setting.email')" prop="email" style="width: 500px">
                        <Input type="text" v-model.trim="formData.email" :placeholder="$t('inputPlaceholder')" ></Input>
                    </FormItem>

                    <FormItem :label="$t('setting.emailHost')" prop="emailHost" style="width: 500px">
                        <Input type="text" v-model.trim="formData.emailHost"    :placeholder="$t('inputPlaceholder')" ></Input>
                    </FormItem>

                    <FormItem :label="$t('setting.emailPort')" prop="emailPort" style="width: 500px">
                        <Input type="text" v-model.trim="formData.emailPort"  maxlength="10"  :placeholder="$t('inputPlaceholder')" ></Input>
                    </FormItem>

                    <FormItem :label="$t('setting.emailAutoCode')" prop="emailAutoCode" style="width: 500px">
                        <Input type="text" v-model.trim="formData.emailAutoCode"    :placeholder="$t('inputPlaceholder')"></Input>
                    </FormItem>

                    <FormItem :label="$t('setting.brandName')" prop="brandName" style="width: 500px">
                        <Input type="text" v-model.trim="formData.brandName" maxlength="50"  :placeholder="$t('inputPlaceholder')" ></Input>
                    </FormItem>


                    <!-- <FormItem :label="$t('setting.brandName')" prop="brandName" style="width: 500px">
                        <SearchSelect ref="pageId" :url="smsesList" labelName='pageId' isMultiple='2' valName='pageId'
                            labelNameNew="description" keyword="pageId" :labelInValue="true"
                            :placeholderText="type == 1 ? $t('selectPlaceholder') : $t('selectloadingPlaceholder')"
                            @setSelected="setSelectVal($event, 'pageId')"></SearchSelect>
                    </FormItem> -->



                    <FormItem :label="$t('setting.companyAddress')" prop="companyAddress" style="width: 500px">
                        <Input type="text" v-model.trim="formData.companyAddress" maxlength="50"  :placeholder="$t('inputPlaceholder')" ></Input>
                    </FormItem>
                   
                    <FormItem :label="$t('setting.website')" prop="website" style="width: 500px">
                        <Input type="text" v-model.trim="formData.website" :placeholder="$t('inputPlaceholder')" ></Input>
                    </FormItem>
                    <FormItem :label="$t('setting.eStore')" prop="eStore" style="width: 500px">
                        <Input type="text" v-model.trim="formData.eStore" :placeholder="$t('inputPlaceholder')" ></Input>
                    </FormItem>

                     <FormItem :label="$t('setting.serviceTel')" prop="serviceTel" style="width: 500px">
                        <Input type="text" v-model.trim="formData.serviceTel" maxlength="50"  :placeholder="$t('inputPlaceholder')" ></Input>
                    </FormItem>

                    <FormItem  v-if="type==2" :label="$t('setting.registerTime')" prop="registerTime" style="width: 500px">
                        <Input type="text" v-model.trim="formData.registerTime1" :placeholder="$t('inputPlaceholder')"
                            :disabled='roleType == 2'></Input>
                    </FormItem>
                    
                   
                </div>
                <div style="marginLeft:50px">

                    <FormItem :label="$t('setting.starLevel')" prop="starLevel" style="width: 500px">
                        <Rate show-text v-model="formData.starLevel"  />
                    </FormItem>
        
                    <FormItem :label="$t('setting.smsCharge')" prop="smsCharge" style="width: 500px">
                         <RadioGroup v-model="formData.smsCharge" style="marginLeft:0px">
                             <Radio :label="$t('yes')" ></Radio>
                             <Radio :label="$t('no')" ></Radio>
                         </RadioGroup>
                    </FormItem>
                    <FormItem :label="$t('setting.activateCharge')" prop="activateCharge" style="width: 500px">
                         <RadioGroup v-model="formData.activateCharge" style="marginLeft:0px">
                             <Radio :label="$t('yes')" ></Radio>
                             <Radio :label="$t('no')" ></Radio>
                         </RadioGroup>
                    </FormItem>
                    <FormItem :label="$t('setting.homeShow')" prop="homeShow" style="width: 500px">
                         <RadioGroup v-model="formData.homeShow" style="marginLeft:0px">
                             <Radio :label="$t('yes')" ></Radio>
                             <Radio :label="$t('no')" ></Radio>
                         </RadioGroup>
                    </FormItem>
                    <FormItem :label="$t('setting.zeroBalanceSms')" prop="zeroBalanceSms" style="width: 500px">
                         <RadioGroup v-model="formData.zeroBalanceSms" style="marginLeft:0px">
                             <Radio :label="$t('yes')" ></Radio>
                             <Radio :label="$t('no')" ></Radio>
                         </RadioGroup>
                    </FormItem>
        
                    <FormItem :label="$t('setting.zeroBalanceActivate')" prop="zeroBalanceActivate" style="width: 500px">
                         <RadioGroup v-model="formData.zeroBalanceActivate" style="marginLeft:0px">
                             <Radio :label="$t('yes')" ></Radio>
                             <Radio :label="$t('no')" ></Radio>
                         </RadioGroup>
                    </FormItem>

                     <FormItem :label="$t('setting.language')" prop="status"  style="min-width: 500px">
                         <Select  :placeholder='$t("selectPlaceholder")'  clearable class="input-div" v-model="formData.language" style="width: 340px;">
                             <Option v-for="(item, index) in selectObj.languageList" :value="item.id" :key="index">{{item['val']}}</Option>
                         </Select>
                     </FormItem>

                     <FormItem  v-if="type==2" :label="$t('setting.apiId')" prop="apiId" style="min-width: 500px">
                        <div>{{ apiId }}</div>
                    </FormItem>

                    <FormItem  v-if="type==2" :label="$t('setting.password')" style="min-width: 500px;marginBottom:0">
                        <span style="marginRight:20px">{{ apiKey }}</span>
                        <Poptip confirm :title="$t('setting.resetTip')" :ok-text="$t('confirm')" :cancel-text="$t('cancel')"
                            @on-ok="resetPwd">
                            <Button type="info" ghost size="small" style="lineHeight:normal">{{ $t('setting.reset')
                            }}</Button>
                        </Poptip>

                    </FormItem>

    

                    <FormItem :label="$t('setting.imageFid')" prop="imageFid" class="logoCon ivu-form-item-required" style="min-width: 500px;display: flex;align-items: center;">
                        <ImgUpload style="margin-top: 20px" ref="upLogoImg" :action="uploadUsersAvatar" :hasUpload="hasUpload" :num="1"  @setThumbUrl="setThumbUrlthumb" @removeThumbUrl='removeThumbUrlLogo'></ImgUpload>
                    </FormItem>

                     <FormItem :label="$t('setting.imageBg')" prop="appbg_Images" class="logoCon"   style="min-width: 500px;display: flex;align-items: center;">
                        <ImgUpload style="margin-top: 20px" ref="upBgImg" :action="uploadUsersAvatar"  :hasUpload="hasUpload" :num="6" :types="['png','jpg']" :nameReg="/(light|dark)_\w+/" @setThumbUrl="setThumbUrlthumbBg"  @removeThumbUrl='removeThumbUrl'></ImgUpload>
                        <span class="simple-size">{{ $t('setting.imageBgTip') }}</span>
                    </FormItem>



                     <FormItem :label="$t('setting.remark')" prop="remark" style="width: 500px">
                        <Input  v-model.trim="formData.remark"  maxlength="100"  show-word-limit  type="textarea" :placeholder="$t('inputPlaceholder')" ></Input>
                    </FormItem>

                    <FormItem>
                         <Button :loading="disabled"  type="primary" @click="subData('formData')" style="marginRight:20px">{{$t('save')}}</Button>
                    </FormItem>
                </div>
        
            </Form>
    
    </div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import moment from 'moment';
import ImgUpload from "@/views/common/upload";
import SearchSelect from '@/views/common/selectList.vue';  //20220415
import { mapMutations,mapState } from 'vuex'
    export default {
        name: "settingModel",
        props: {
            showModel: Boolean,
            offModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Object,

        },
        components: {
            ImgUpload,
            SearchSelect
        },
        data() {
            return {   
                uploadUsersAvatar:this.config.urlArray.uploadImg, //上传图片接口
                smsesList:this.config.urlArray.smsesList, //城市接口
                hasUpload: [], //已上传图片
                disabled: false,//禁用确定按钮
                title: '',//弹框标题
                apiKey: "",
                apiId: "",
                formData: {//表单数据
                    macMaker:'',
                    companyName:'',
                    email:'',
                    brandName:'',
                    companyAddress:'',
                    serviceTel:'',
                    website:'',
                    eStore:'',
                    remark:'',
                    starLevel:1,
                    smsCharge:this.$t('yes'),
                    activateCharge:this.$t('yes'),
                    homeShow:this.$t('yes'),
                    zeroBalanceSms:this.$t('yes'),
                    zeroBalanceActivate:this.$t('yes'),
                    imageFid:'',
                    appbg_Images:[],
                    language:'zh_CN',
                    emailHost:'',//邮箱服务商主机地址
                    emailPort:'',//端口
                    emailAutoCode:'',//授权码
                }, 
                
            }
        },
       
        computed:{
            ...mapState(['local','selectId','uInfo']),
            selectObj(){
                return {
                    languageList:[
                        {id: 'zh_CN',val:this.$t('zh_CN')},
                        {id: 'en_US',val:this.$t('en_US')}
                    ]
                }
            },
            roleType(){
	        	let res = '2'
	        	if(this.$store.state.uInfo && this.$store.state.uInfo.roleType){
	        	 res = this.$store.state.uInfo.roleType
	        	}
	        	return res
	        },
            ruleCustom(){
                return {//验证
                    companyName: [
                        {required: true, message:this.$t('required'),trigger: 'blur' },
                    ],
                    email: [
                        {required: true, message:this.$t('required'),trigger: 'blur' },
                        {type: 'string', pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/, message: this.$t('ruleCustom.format'), trigger:'blur'},
                    ],
                    macMaker:[
                        {required: true, message:this.$t('required'),trigger: 'blur' },
                        {type: 'string', pattern: /^[^\u4e00-\u9fa5]+$/, message: this.$t('ruleCustom.format'), trigger:'blur'},
                    ],
                    brandName: [
                        {required: true, message:this.$t('required'),trigger: 'blur' },
                    ],
                    companyAddress: [
                        {required: true, message:this.$t('required'),trigger: 'blur' },
                    ],
                    serviceTel: [
                        {required: true, message:this.$t('required'),trigger: 'blur' },
                        // {type: 'string', pattern: /^(\+\d{1,3})(\s{1}[1-9]\d{1,2}\s{1})(\d{7,8})$/, message: this.$t('ruleCustom.fixedTelephone'), trigger:'blur'},
                    ],
                    website: [
                        {required: true, message:this.$t('required'),trigger: 'blur' },
                         {type: 'string', pattern: /^[a-zA-z]+:\/\/[^\s]+$/, message: this.$t('ruleCustom.format'), trigger:'blur'},
                    ],
                    eStore: [
                        {required: true, message:this.$t('required'),trigger: 'blur' },
                        {type: 'string', pattern: /^[a-zA-z]+:\/\/[^\s]+$/, message: this.$t('ruleCustom.format'), trigger:'blur'},
                    ],
                    remark: [
                        {required: true, message:this.$t('required'),trigger: 'blur' },
                    ],
                    emailHost:[
                        {required: true, message:this.$t('required'),trigger: 'blur' },
                        {type: 'string', pattern: /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/, message: this.$t('ruleCustom.format'), trigger:'blur'},
                    ],
                    emailPort:[
                        {required: true, message:this.$t('required'),trigger: 'blur' },
                        {type: 'string', pattern: /^[0-9]+$/, message: this.$t('ruleCustom.format'), trigger:'blur'},
                    ],
                    emailAutoCode:[
                        {required: true, message:this.$t('required'),trigger: 'blur' },
                        // {type: 'string', pattern: /^[0-9a-zA-Z]+$/, message: this.$t('ruleCustom.format'), trigger:'blur'},
                    ],
                    imageFid: [
                      { required: true, message: this.$t('required'), trigger: 'change' }
                    ],
                    // appbg_Images: [
                    //   { required: true, message: this.$t('required'), trigger: 'blur', type: 'array' }
                    // ],
                }
            },

        },
        created(){
           if(this.type==2){
               this.title =  this.$t('setting.title')
               this.getData()
           }
        },
        watch:{
            showModel(val){
                if(val === true) {   
                    this.title = this.type==1? this.$t('setting.addTitle'): this.$t('setting.title')
                    // this.$nextTick(() => {//select赋值
                    //     this.$refs.pageId.setQuery(null)
                    // });
            
                } else { //关闭弹框后要做的处理
                    this.resetForm();
                }
            },
            
            local(){
                this.formData.smsCharge = this.$t('yes')
                this.formData.activateCharge = this.$t('yes')
                this.formData.homeShow = this.$t('yes')
                this.formData.zeroBalanceSms = this.$t('yes')
                this.formData.zeroBalanceActivate = this.$t('yes')
            }
        },
        methods: {
             ...mapMutations([
              'setLocal'
            ]),
            setThumbUrlthumb(item) {
              this.formData.imageFid = item.data;
            },
            setThumbUrlthumbBg(item) {
                if (!item.data) return
                console.log('item',item)

                // let reg = /(light|dark)_\\w+\\.png/
                // console.log('reg')
                //  if(reg.test(item.file.name)){
                    
                //  }else{
                //     this.$Notice.warning({
                //         title: this.$t('upError.formatError'),
                //         desc:  this.$t('setting.imageBgTip')
                //     });
                //  }
                 this.formData.appbg_Images.push(item.data);
            },
            removeThumbUrl(index) {
                this.formData.appbg_Images.splice(index, 1)
            },
            removeThumbUrlLogo() {
                this.formData.imageFid = "";
            },
            resetPwd() {//重置api密码
                this.axios.post(this.config.urlArray.changeApiKey, { id: this.selectId }).then((result) => {
                    common.ajaxMsg(result.data, true, () => {
                        this.apiKey = result.data.data.apiKey
                    })
                })
            },
            getData() {
                this.axios.post(this.config.urlArray.dealerInfo, { id: this.selectId }).then((result) => {
                common.ajaxMsg(result.data, false, () => {
                    let resData = result.data.data
                    this.formData = { ...resData }
                    this.apiKey = this.formData.apiKey
                    this.apiId = this.formData.apiId
                    this.formData.smsCharge = resData.smsCharge ? this.$t('yes') : this.$t('no');
                    this.formData.activateCharge = resData.activateCharge ? this.$t('yes') : this.$t('no');
                    this.formData.homeShow = resData.homeShow ? this.$t('yes') : this.$t('no');
                    this.formData.zeroBalanceSms = resData.zeroBalanceSms ? this.$t('yes') : this.$t('no');
                    this.formData.zeroBalanceActivate = resData.zeroBalanceActivate ? this.$t('yes') : this.$t('no');
                    // this.formData.registerTime1 = moment(this.formData.registerTime*1+8*60*60*1000).format('YYYY-MM-DD HH:mm:ss')
                    this.formData.registerTime1 = moment(this.formData.registerTime * 1).format('YYYY-MM-DD HH:mm:ss')
                    this.formData.language = resData.language.replace(/\-/, '_')
                    
                    this.formData.appbg_Images = resData.appbgImage?resData.appbgImage.split(','):[]
                    this.$nextTick(() => {//图片赋值
                        let hasUpload1 = [{
                            status: 'finished',
                            response: { data: this.formData.imageFid }
                        }]
                        this.$refs.upLogoImg.setHasUpload(hasUpload1)

                        let hasUpload2 = this.formData.appbg_Images.map(item => { // 处理规格数组的结构
                            item = {
                                status: 'finished',
                                response: { data: item }
                            }
                            return item
                        })

                        this.$refs.upBgImg.setHasUpload(hasUpload2)

                        // this.$refs.pageId.setDefVal(Number(this.formData.pageId));

                    });
                    // console.log('this.formData',this.formData)

                    this.loading = false
                });
                })
            },
            subData(name) {//提交表单
                //  console.log('formdata',this.formData)
                this.$refs[name].validate((valid) => {
                    if (valid) {  

                        this.disabled = true;        

                        let resObj = {
                            ...this.formData,
                            activateCharge: this.formData.activateCharge == this.$t('yes')?true:false,
                            homeShow : this.formData.homeShow == this.$t('yes')?true:false,
                            smsCharge : this.formData.smsCharge == this.$t('yes')?true:false,
                            zeroBalanceSms : this.formData.zeroBalanceSms == this.$t('yes')?true:false,
                            zeroBalanceActivate : this.formData.zeroBalanceActivate == this.$t('yes')?true:false,
                            appbgImage:this.formData.appbg_Images.join(',')
                           
                        }
                        if(this.type==2){
                            resObj.id = this.editFormData.id
                        }

                        let url = this.type==1?this.config.urlArray.addDealer:this.config.urlArray.dealerInfoSet

                        // console.log({...resObj})

                        this.axios.post(url, {...resObj}).then((result) => {
                            common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                this.disabled = false;
                                if(this.type==1) this.cancel();
                                if(this.type==2) this.getData()
                                
                                if(this.fn) this.fn()

                                if (this.roleType == 2) {
                                    let language = this.formData.language.replace(/\_/, '-')
                                    this.setLocal({ locale: language, langSet: true })
                                }
                            },()=>{this.disabled = false; })
                            
                        }).catch((err) => {
                           
                        });
                        
                    }
                })
            },
            cancel() {//对话框关闭
                this.resetForm()
                this.$emit('update:showModel',false);
                this.$emit('update:offModel',true);
            },
            resetForm() {//重置表单
                this.formData.starLevel=1;
                this.formData.smsCharge=this.$t('yes');
                this.formData.activateCharge=this.$t('yes');
                this.formData.homeShow=this.$t('yes');
                this.formData.zeroBalanceSms=this.$t('yes');
                this.formData.zeroBalanceActivate=this.$t('yes');
                this.formData.language='zh_CN';
                this.disabled = false;//恢复提交按钮为激活状态

                    
                // if(this.formData.imageFid){
                //     this.$refs.upLogoImg.clearImg()
                // }
                // this.formData.imageFid='';

                // if(this.formData.appbg_Images.length>0){
                //     this.$refs.upBgImg.clearImg()
                // }
                // this.formData.appbg_Images = []
                // console.log('this.$refs.upLogoImg',this.$refs.upLogoImg)
                // console.log('this.$refs.upBgImg',this.$refs.upBgImg)

                if(this.$refs.upLogoImg){
                    this.$refs.upLogoImg.clearImg()
                }
                this.formData.imageFid='';

                if(this.$refs.upBgImg){
                    this.$refs.upBgImg.clearImg()
                }
                this.formData.appbg_Images = []






                this.$refs.formData.resetFields();//重置表单

                
            }
        }
    }
</script>
<style lang="less" scoped>
.simple-size {
    color: #ccc;
    font-size: 12px;
    height: 20px;
    padding: 0;
    margin: 0;
}
.logoCon /deep/ .ivu-form-item-content{
    margin-left: 0px !important;
}
.verAddCon{
    position: relative;
    .title{
        font-size: 20px;
        padding: 4px 0 20px;
    }
    .colseButton{
        position: absolute;
        right: -18px;
        top:-18px;
        cursor: pointer;
    }
}
/deep/ .ivu-form .ivu-form-item-label{
    width: 160px !important;
    flex-shrink: 0;
}
/deep/ .ivu-form-item-content {
    margin-left: 160px !important;
    flex-grow: 1;
}

</style>
